import { parseISO } from 'date-fns';
import { Shift } from '../types';

function parseShiftDateTime(dateTimeStr: string): Date {
  if (!dateTimeStr.includes('Z') && !dateTimeStr.includes('+') && !dateTimeStr.includes('-', 10)) {
    const [datePart, timePart] = dateTimeStr.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);
    return new Date(year, month - 1, day, hour, minute, second || 0);
  }
  return parseISO(dateTimeStr);
}

/** Gross shift length from start/end when stored hour fields are missing or zero. */
export function deriveShiftDurationHours(shift: Pick<Shift, 'startTime' | 'endTime'>): number {
  if (!shift.startTime || !shift.endTime) return 0;
  try {
    const start = parseShiftDateTime(shift.startTime);
    const end = parseShiftDateTime(shift.endTime);
    let minutes = (end.getTime() - start.getTime()) / (1000 * 60);
    if (minutes <= 0) minutes += 24 * 60;
    return Math.round(Math.max(0, minutes / 60) * 100) / 100;
  } catch {
    return 0;
  }
}

/** Total scheduled hours for display (paid + unpaid, or derived from times). */
export function getShiftTotalHours(shift: Shift): number {
  const paid = Number(shift.paidHours ?? 0);
  const unpaid = Number(shift.unpaidHours ?? 0);
  const stored = paid + unpaid;
  if (stored > 0) return stored;
  return deriveShiftDurationHours(shift);
}
